import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { CarLinerPdfDownloadIndicatorServiceService } from '../../services/car-liner-pdf-download-indicator-service.service';

@Component({
    selector: 'car-liner-pdf-download-indicator',
    templateUrl: './car-liner-pdf-download-indicator.component.html',
    styleUrls: ['./car-liner-pdf-download-indicator.component.scss'],
    standalone: false
})
export class CarLinerPdfDownloadIndicatorComponent implements OnInit, OnDestroy {
  public unsubscribe: Subject<void> = new Subject();

  public isDownloading = false;
  data;

  constructor(protected carLinerPdfDownloadIndicatorService: CarLinerPdfDownloadIndicatorServiceService) {}

  ngOnInit(): void {
    this.carLinerPdfDownloadIndicatorService
      .isDownloading()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(({ downloading, data }) => {
        this.isDownloading = downloading;
        this.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
